import React, { useState, useEffect } from 'react';
import CampaignPopup from './CampaignPopup';

const StartScreen = ({ bestScore, onStartGame }) => {
  const [showCampaign, setShowCampaign] = useState(false);

  useEffect(() => {
    // Check if user has already participated or dismissed the campaign
    const hasParticipated = localStorage.getItem('campaign_participated');
    const hasDismissed = sessionStorage.getItem('campaign_dismissed');
    
    console.log('Campaign Check:', { hasParticipated, hasDismissed });
    
    // Show campaign popup if not participated and not dismissed in this session
    if (!hasParticipated && !hasDismissed) {
      // Show after a short delay for better UX
      const timer = setTimeout(() => {
        console.log('Showing campaign popup');
        setShowCampaign(true);
      }, 500);
      return () => clearTimeout(timer);
    } else {
      console.log('Campaign not shown - already participated or dismissed');
    }
  }, []);

  const handleCloseCampaign = () => {
    setShowCampaign(false);
    sessionStorage.setItem('campaign_dismissed', 'true');
  };

  const handlePlayFromCampaign = () => {
    setShowCampaign(false);
    onStartGame();
  };

  const handlePlayClick = () => {
    onStartGame();
  };
  return (
    <div className="screen start-screen">
      {showCampaign && (
        <CampaignPopup 
          onClose={handleCloseCampaign}
          onPlayNow={handlePlayFromCampaign}
        />
      )}
      
      <div className="start-container">
        <div className="game-title">
          <h1>Starknet Ninja</h1>
          <div className="subtitle">Slice & Dice</div>
        </div>
        
                <div className="logo">
          <div className="token-logo">⬡</div>
        </div>
        
        <div className="instructions">
          <p>Slash <span className="highlight">tokens</span> to earn points!</p>
          <p>Avoid bombs or lose a life!</p>
        </div>
        
        <div className="best-score">
          <span>Best Score: <span>{bestScore}</span> points</span>
        </div>
        
        {/* Debug button to test campaign popup */}
        <button 
          className="btn btn--secondary" 
          type="button"
          onClick={() => {
            localStorage.removeItem('campaign_participated');
            sessionStorage.removeItem('campaign_dismissed');
            setShowCampaign(true);
          }}
          style={{ marginBottom: '10px', fontSize: '12px', padding: '8px 16px' }}
        >
          Show Campaign Popup
        </button>
        
        <button 
          className="btn btn--primary btn--lg play-btn" 
          type="button"
          onClick={handlePlayClick}
        >
          <span>PLAY</span>
        </button>
      </div>
    </div>
  );
};

export default StartScreen;